import React from "react";
import { SectionCard } from "../../../components/ui";

export default function EventResultsPanel({ children }) {
  return (
    <SectionCard className="events-panel-shell events-panel-results" sx={{ p: 1.75 }}>
      <div className="events-panel-content">{children}</div>
    </SectionCard>
  );
}
